// @flow
import React from "react";
import { connect } from "react-redux";

import { Translate, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelectInput from "../../../comum/SelectInput";

import { NumberField } from "@quantum/ui";

import {
  getValoresBaseDeflator,
  selecionarValorBaseDeflator,
  getValorBaseDeflatorSelecionado,
  getDeflatorSelecionado,
  getValorBaseDeflatorOutroSelecionado,
  getSeparadorDecimal,
  selecionarValorBaseDeflatorOutro,
  type ActionCreator,
} from "../../../../state";
import {
  type EnumCodigoDescricao,
  ID_VALOR_BASE_DEFLATOR_OUTRO,
} from "../../../../model";

type Props = {
  listaValoresBaseDeflator: Array<EnumCodigoDescricao>,
  valorBaseDeflatorSelecionado: string,
  selecionarValorBaseDeflator: ActionCreator,
  selecionarValorBaseDeflatorOutro: ActionCreator,
  deflatorSelecionado: string,
  exibirInputValorBaseOutro: boolean,
  valorBaseDeflatorOutro: ?number,
  separadorDecimal: string,
};

function SelecaoValorBaseDeflator({
  listaValoresBaseDeflator,
  valorBaseDeflatorSelecionado,
  selecionarValorBaseDeflator,
  selecionarValorBaseDeflatorOutro,
  deflatorSelecionado,
  exibirInputValorBaseOutro,
  valorBaseDeflatorOutro,
  separadorDecimal,
}: Props) {
  function onChange(valorBase) {
    selecionarValorBaseDeflator(valorBase);
    if (valorBase !== ID_VALOR_BASE_DEFLATOR_OUTRO) {
      selecionarValorBaseDeflatorOutro(null);
    }
  }

  function onChangeValorBaseOutro(valorBaseOutro) {
    selecionarValorBaseDeflatorOutro(valorBaseOutro);
  }

  if (!deflatorSelecionado) {
    return null;
  }

  const valorBaseOutroInput = exibirInputValorBaseOutro ? (
    <NumberField
      className="ConfiguracaoMedida__input"
      decimalScale={2}
      min={-999999}
      max={999999}
      onChangeValue={onChangeValorBaseOutro}
      value={valorBaseDeflatorOutro}
      thousandSeparator={""}
      decimalSeparator={separadorDecimal}
    />
  ) : null;

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        <Translate>ConfiguracaoIndicador.ValorBase</Translate>
      </label>
      <SelectInput
        className="ConfiguracaoMedida__input-select"
        options={listaValoresBaseDeflator}
        value={valorBaseDeflatorSelecionado}
        onChange={onChange}
        size={1}
        multiple={false}
        campoDescricao="traducao"
        campoId="codigo"
      />
      {valorBaseOutroInput}
    </div>
  );
}

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaValoresBaseDeflator: getValoresBaseDeflator(state).map(
        valorBase => ({
          ...valorBase,
          traducao: ownProps.translate(valorBase.descricao),
        })
      ),
      valorBaseDeflatorSelecionado: getValorBaseDeflatorSelecionado(state),
      deflatorSelecionado: getDeflatorSelecionado(state),
      exibirInputValorBaseOutro:
        getValorBaseDeflatorSelecionado(state) === ID_VALOR_BASE_DEFLATOR_OUTRO,
      valorBaseDeflatorOutro: getValorBaseDeflatorOutroSelecionado(state),
      separadorDecimal: getSeparadorDecimal(state),
    }),
    { selecionarValorBaseDeflator, selecionarValorBaseDeflatorOutro }
  )
)(SelecaoValorBaseDeflator);
